import { FC, ReactNode, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import ImportChart from '../../components/charts/ImportChart'
import TrackingChart from '../../components/charts/TrackingChart'
import LogoText from '../../components/logo/LogoText'
import SideBarNav from '../../components/nav/SideBarNav'
import ServerAvailability from '../../components/ServerAvailability'
import { UserMenu } from '../../components/user/UserMenu'
import SseWidget from '../../components/sse/SseWidget'

export interface IHeaderLayout {
  title?: ReactNode
  subTitle?: ReactNode
  actions?: ReactNode
}

const MainLayout: FC = () => {
  const [isMobileMenu, setIsMobileMenu] = useState<boolean>()
  const location = useLocation()
  const navigate = useNavigate()

  // -- Redirect for main Page
  useEffect(() => {
    if (location.pathname === '/') navigate('/imports')
  }, [location])

  return (
    <div>
      {/* <!-- Mobail menu --> */}
      {true && (
        <div className={`relative z-50 lg:hidden`} role='dialog' aria-modal='true'>
          <div
            className='fixed inset-0 bg-gray-900/70 transition duration-300'
            role='button'
            tabIndex={-1}
            onClick={() => setIsMobileMenu(() => false)}
            style={{
              opacity: isMobileMenu ? 1 : 0,
              visibility: isMobileMenu ? 'visible' : 'hidden',
              transition: 'opacity 600ms, visibility 600ms',
            }}
          />

          <div
            className='fixed inset-0 flex min-w-[300px] max-w-[400px] w-[100vw]'
            style={{
              left: isMobileMenu ? 0 : '-100%',
              transition: 'all .4s ease-in-out',
            }}
          >
            <div className='relative mr-16 flex w-full max-w-xs flex-1 transition ease-in-out duration-300 transform'>
              <div className='absolute left-full top-0 flex w-16 justify-center pt-5 transition ease-in-out duration-300 transform'>
                <button
                  type='button'
                  className='-m-2.5 p-2.5 z-50'
                  onClick={() => setIsMobileMenu(() => false)}
                >
                  <svg
                    className='h-7 w-7 text-white'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth='1.5'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
                  </svg>
                </button>
              </div>

              <div className='flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4'>
                <div className='flex h-16 shrink-0 items-center'>
                  <LogoText />
                </div>
                <SideBarNav />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <!-- Static sidebar for desktop --> */}
      <div className='hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col'>
        <div className='flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4'>
          <div className='flex h-16 shrink-0 items-center'>
            <LogoText />
          </div>
          <div className='flex flex-col gap-[3em]'>
            <SideBarNav />
            <div className='flex justify-center'>
              <div className='w-[80%] flex flex-col gap-[2em]'>
                <ImportChart />
                <TrackingChart />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='lg:pl-72'>
        <div className='sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8'>
          <button
            type='button'
            tabIndex={-1}
            className='-m-2.5 p-2.5 text-gray-700 lg:hidden'
            onClick={() => setIsMobileMenu(() => true)}
          >
            <span className='sr-only'>Open sidebar</span>
            <svg
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              aria-hidden='true'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
              />
            </svg>
          </button>

          {/* <!-- Separator --> */}
          <div className='h-6 w-px bg-gray-200 lg:hidden' aria-hidden='true'></div>

          <div className='flex flex-1 gap-x-4 self-stretch justify-end lg:gap-x-6'>
            <div className='flex items-center gap-x-4 lg:gap-x-6'>
              <div className='flex gap-4'></div>

              <div>
                <SseWidget />
              </div>

              <div>
                <ServerAvailability />
              </div>

              {/* <!-- Separator --> */}
              <div
                className='hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200'
                aria-hidden='true'
              ></div>
              {/* <!-- Profile dropdown --> */}
              <div className='relative'>
                <UserMenu />
              </div>
            </div>
          </div>
        </div>
      </div>
      <main className='py-10 lg:pl-72'>
        <Outlet />
      </main>
    </div>
  )
}

export default MainLayout
